import React from "react";
import { TrackingRouter } from "../routing/trackingRouter";
import { Wrapper } from "./statusContainer.styles";

export const StatusContainer = ({ statusThemeColor, children }) => {
  return (
    <Wrapper $borderColor={statusThemeColor}>
      <TrackingRouter>{children}</TrackingRouter>
    </Wrapper>
  );
};
